"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchJobsResponse = void 0;
var job_1 = require("../job/job");
/**
 * Search Jobs Response
 * @doc SearchJobsResponse
 */
var SearchJobsResponse = /** @class */ (function () {
    function SearchJobsResponse(data) {
        this.nextPageToken = null;
        this.jobs = [];
        this.nextPageToken = data.nextPageToken;
        this.jobs = data.jobs.map(function (job) {
            return new job_1.Job(job);
        });
    }
    return SearchJobsResponse;
}());
exports.SearchJobsResponse = SearchJobsResponse;
//# sourceMappingURL=search-jobs-response.js.map